<template>
  <div :class="['c-toast-black', { 'is-active': data.visible }, data.type]">
    <span class="text">{{ data.message }}</span>
  </div>
</template>
<script setup name="toast">
import { reactive, onMounted, defineProps } from "vue";
import { useToast } from "@/components/paintpro/composables/useToast";

const props = defineProps({
  toastId: {
    // props로 고유 ID 받기
    type: String,
    required: false,
  },
});

const data = reactive({
  id: "",
  message: "",
  type: "",
  visible: false,
});

onMounted(() => {
  const { visible, message, type } = useToast(props.toastId);
  data.id = props.toastId;
  data.message = message;
  data.visible = visible;
  data.type = type;
});
</script>
